import apiFetch from '../../apiFetch'

export default function (values, token) {
  return apiFetch({endPoint: `TipoIntervencion/editTipoIntervencion`, method: 'POST', body: values, token: token})
}
